<template>
  <div class="admin-page row-block" :style="{ minHeight: minHeight }">
    <div class="filter-container" :style="{ width: '250px' }">
      <adminFilter
        :minHeight="minHeight"
        :disabled="false"
        :title="'會員帳號搜尋'"
        :filters="{
          init: init,
          options: filterOptions
        }"
        @changeFilters="(c, search) => { filters = c; search && searchDatas(c) }"
      ></adminFilter>
    </div>
    <div class="main-container row-block" :style="{ flex: 1, height: minHeight }">
      <div v-if="onSearch" class="mask center-block" :style="{ height: '100%', width: '100%', 'min-width': '1350px' }">
        <!-- <img :src="require('../../assets/images/loading.gif')"> -->
        <img :src="require('../../assets/images/upload.svg')" alt="">
      </div>
      <div class="main-block col-block" :style="{ height: '100%', width: '100%', 'min-width': '1350px' }">
        <div class="title-container row-block">
          <div class="title">會員帳號管理</div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div :style="{ height: '10px' }"></div>
        <div class="table-feild col-block" :style="{ flex: 1 }">
          <div class="table-container col-block" :style="{ height: '50px' }">
            <div class="thead default-shadow">
              <div class="tr row-block">
                <div
                  v-for="(option, index) in tableOptions"
                  :key="index"
                  class="th row-block"
                  :class="option.class"
                  :style="option.width ? { width: option.width } : { flex: 1 }"
                  @click="e => option.sort !== false && tableSortBy(option.value)"
                >
                  <span>{{ option.title }}</span>
                  <div :style="{ width: '5px' }"></div>
                  <i v-if="option.sort !== false" :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.value)] || '')]" aria-hidden="true"></i>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-container col-block sub-shadow" :style="{ flex: 1 }">
            <div class="tbody" :style="{ flex: 1 }">
              <div :style="{ height: 0 }">
                <div class="tr row-block" v-for="(account, cindex) in accounts" :key="cindex">
                  <div class="container-block row-block">
                    <div
                      v-for="(option, index) in tableOptions"
                      :key="index"
                      class="td row-block"
                      :class="option.class"
                      :style="option.width ? { width: option.width } : { flex: 1 }"
                    >
                      <div v-if="option.value === 'email'" class="row-block" :style="{ width: '100%' }">
                        <img v-if="account.activated_at" :src="require('../../assets/images/active-icon.svg')">
                        <div :style="{ width: '10px' }"></div>
                        <span :title="(option.display || (x => x))(account[option.value], cindex)" :style="(option.style || (() => {}))(account[option.value])">{{ (option.display || (x => x))(account[option.value], cindex) || '--' }}</span>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                      <div v-else-if="option.value === '_OPTIONS'">
                        <div class="option row-block" v-if="account.role !== 'admin'">
                          <div class="row-block" :style="{ flex: 1 }">
                            <select :value="account.role" @change="e => account.role = e.target.value">
                              <option v-for="(option, index) in roleOptions" :key="index" :value="option.value">{{ option.title }}</option>
                            </select>
                            <div :style="{ width: '10px' }"></div>
                            <button type="button" name="button" class="main-button option-button update" :class="{ loading: account.onSubmitRole }" @click="e => updateAccountRole(account)">
                              <span>更新</span>
                            </button>
                            <div :style="{ flex: 1 }"></div>
                          </div>
                          <div :style="{ width: '20px' }"></div>
                          <div class="row-block">
                            <button type="button" name="button" class="main-button delete" @click="e => deleteAccount(account)">
                              <i class="fa fa-trash-o" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <span v-else :title="(option.display || (x => x))(account[option.value], cindex)" :style="(option.style || (() => {}))(account[option.value])">{{ (option.display || (x => x))(account[option.value], cindex) || '--' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="page-container center-block">
            <pageButtons
              v-if="pageData.total"
              :default="pageData.selectedPage"
              :display="pageData.display"
              :total="pageData.total"
              :buttonRange="pageData.buttonRange"
              @selectPage="page => { pageData.selectedPage = page; searchDatas() }"
            ></pageButtons>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getAccounts, putUpdateAccountRole, deleteAccount } from '../../api'
import adminFilter from '../../components/admin/filter'
import pageButtons from '../../components/tool/pageButtons'
import routeLoading from '../../mixins/routeLoading'
import toastMethods from '../../mixins/toastMethods'
import { dateFormat } from '../../constants/global/util'
import { occupationOptions, roleOptions } from '../../constants/global/data'

export default {
  components: {
    adminFilter,
    pageButtons
  },
  mixins: [
    routeLoading,
    toastMethods
  ],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      accounts: [],
      init: {},
      filters: {},
      onSearch: false,
      pageData: {
        selectedPage: 1,
        display: 12,
        total: null,
        buttonRange: 7
      },
      sort: {
        value: [],
        order: []
      }
    }
  },
  computed: {
    // static
    filterOptions () {
      return [
        {
          title: '關鍵字搜尋',
          value: 'query',
          type: 'input',
          placeholder: () => '如：帳號、姓名、電子信箱...'
        }
      ]
    },
    tableOptions () {
      return [
        {
          title: '帳號',
          value: 'account',
          width: '150px'
        },
        {
          title: '姓名',
          value: 'name',
          width: '150px'
        },
        {
          title: '電子信箱',
          value: 'email',
          sortMap: data => data.activated_at
        },
        {
          title: '身份',
          value: 'occupation',
          width: '150px',
          display: value => value ? occupationOptions.map(option => option.value).includes(value) ? value : '其他(' + value + ')' : ''
        },
        {
          title: '註冊日期',
          value: 'created_at',
          width: '150px',
          display: value => value ? dateFormat(new Date(value), 'yyyy/MM/dd') : ''
        },
        {
          title: '管理',
          value: '_OPTIONS',
          width: '240px',
          sort: false
        }
      ]
    },
    // global
    roleOptions () { return roleOptions }
  },
  methods: {
    ...mapActions([
      'setLoadingAction',
      'setModalAction'
    ]),
    async fetchData () {
      await this.fetchAccounts()
    },
    async fetchAccounts (filters) {
      try {
        let config = this.$ls.get('userInfo')
        filters = filters || this.filters || {}
        let data = {
          ...Object.entries(filters).filter(kv => kv[1]).reduce((s, kv) => ({ ...s, [kv[0]]: kv[1] }), {})
        }
        this.pageData.selectedPage && (data.page = this.pageData.selectedPage)
        this.pageData.display && (data.item_per_page = this.pageData.display)
        this.sort.value[0] && (data.order_by = this.sort.value[0])
        this.sort.order[0] && (data.order_method = this.sort.order[0].replace(/^-/, ''))
        let response = await getAccounts(data, config)
        let accounts = response.data.data.elements
        this.pageData.total = response.data.data.items_count
        this.accounts = accounts.map(account => ({
          ...account,
          occupation: account.occupation || account.role
        }))
      } catch (error) {
        throw error
      }
    },
    async searchDatas (init) {
      this.onSearch = true
      if (init) {
        this.init = init
        this.filter = init
      }
      await this.fetchAccounts(init)
      this.onSearch = false
    },
    async updateAccountRole (account) {
      account.onSubmitRole = true
      try {
        let config = this.$ls.get('userInfo')
        let id = account.id
        let role = account.role || 'normal'
        await putUpdateAccountRole(id, role, config)
        this.addToast('success', '更新成功')
        account.onSubmitRole = false
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
        account.onSubmitRole = false
      }
    },
    deleteAccount (account) {
      this.setModalAction({
        action: 'toast',
        customStyles: {
          padding: '0px'
        },
        param: {
          type: 'error',
          content: '<span>此動作不可復原，<br>確認是否刪除帳號: ' + account.account + ' ?</span>',
          buttons: [
            {
              title: '取消',
              type: 'gray',
              icon: 'fa-repeat',
              result: false
            },
            {
              title: '刪除',
              type: 'alert',
              icon: 'fa-trash-o',
              result: true
            }
          ]
        },
        callback: async result => {
          if (result) {
            this.setLoadingAction(true)
            try {
              let config = this.$ls.get('userInfo')
              let id = account.id
              await deleteAccount(id, config)
              this.addToast('success', '刪除成功')
              this.accounts.splice(this.accounts.indexOf(account), 1)
              this.setLoadingAction(false)
            } catch (error) {
              this.addToast('error', !error.response ? error.message : error.response.data)
              this.setLoadingAction(false)
            }
          }
        }
      })
    },
    tableSortBy (value) {
      let position = this.sort.value.indexOf(value)
      if (position === 0) {
        let order =
          this.sort.order[position] === '-asc' ? '-desc' : '-asc'
        this.sort.order.splice(position, 1)
        this.sort.order.unshift(order)
      } else {
        let order =
          position !== -1
            ? this.sort.order[position] === '-asc' ? '-desc' : '-asc'
            : undefined
        position = position !== -1 ? position : 0
        this.sort.value.splice(position, 1)
        this.sort.order.splice(position, 1)
        this.sort.value.unshift(value)
        this.sort.order.unshift(order || '-asc')
      }
      this.searchDatas()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/main/admin.vue